/** 网盘文件接口。 */
import { http } from '@/utils/request'
import type {
  FileContent,
  RenameResult,
  UploadFileItem,
  UploadResult
} from '@/types/upload'
import type { ApiMessage } from '@/types/common'

export function uploadFile(
  file: File,
  onProgress?: (percent: number) => void
): Promise<UploadResult> {
  const formData = new FormData()
  formData.append('file', file)
  return http.post<UploadResult>('/uploads', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    // 上传进度：progress 为 0~1；total 不可用时回退到 loaded/total
    onUploadProgress: (event) => {
      if (!onProgress) return
      const ratio = event.progress ?? (event.total ? event.loaded / event.total : 0)
      onProgress(Math.round(ratio * 100))
    }
  })
}

export function getFiles(): Promise<UploadFileItem[]> {
  return http.get<UploadFileItem[]>('/uploads')
}

export function deleteFile(filename: string): Promise<ApiMessage> {
  return http.delete<ApiMessage>(`/uploads/${encodeURIComponent(filename)}`)
}

export function getFileContent(filename: string): Promise<FileContent> {
  return http.get<FileContent>(`/uploads/${encodeURIComponent(filename)}/content`)
}

export function updateFileContent(filename: string, content: string): Promise<ApiMessage> {
  return http.put<ApiMessage>(`/uploads/${encodeURIComponent(filename)}/content`, { content })
}

export function renameFile(filename: string, newFilename: string): Promise<RenameResult> {
  return http.put<RenameResult>(`/uploads/${encodeURIComponent(filename)}/rename`, {
    new_filename: newFilename
  })
}
